import { PackageX } from "lucide-react";
import { fmtINR } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { KITS_NOTE, BILLING_ENTITY, GSTIN, GST_RATE, gstOn } from "@/lib/offer";

const Row = ({ l, v, testid, strong, accent }) => (
  <div className={`flex justify-between items-baseline py-1.5 ${strong ? "border-t border-slate-200 mt-1 pt-3" : ""}`}>
    <span className={strong ? "font-bold text-[#0A192F]" : "text-slate-600 text-sm"}>{l}</span>
    <span className={`tabular-nums font-['Outfit'] ${strong ? "text-2xl font-black text-[#0A192F]" : accent ? "font-bold text-[#00A389]" : "font-semibold text-[#0A192F]"}`} data-testid={testid}>{v}</span>
  </div>
);

export const BillSummary = ({ fee, pct, label }) => {
  const { L } = useLang();
  const disc = Math.round((fee * pct) / 100);
  const taxable = fee - disc;
  const gst = gstOn(taxable);
  return (
    <div className="rounded-2xl bg-white border border-slate-200 p-5" data-testid="bill-summary">
      <Row l={label} v={fmtINR(fee)} testid="bill-fee" />
      {pct > 0 && <Row l={L(`Coupon discount (${pct}%)`, `कूपन छूट (${pct}%)`)} v={`− ${fmtINR(disc)}`} testid="bill-discount" accent />}
      <Row l={L("Kits", "किट")} v={L("Not included", "शामिल नहीं")} testid="bill-kits" />
      <Row l={L("Taxable value", "कर योग्य मूल्य")} v={fmtINR(taxable)} testid="bill-taxable" />
      <Row l={`GST @ ${GST_RATE}%`} v={`+ ${fmtINR(gst)}`} testid="bill-gst" />
      <Row l={L("Total payable", "कुल देय")} v={fmtINR(taxable + gst)} testid="bill-total" strong />
      <p className="mt-3 text-[11px] text-slate-500" data-testid="bill-billed-by">{L("Billed by", "बिलकर्ता")} {BILLING_ENTITY} {L("for RoboSpark", "(RoboSpark के लिए)")} · GSTIN {GSTIN}</p>
      <p className="mt-2 flex gap-2 text-xs text-[#B42318] bg-[#FFF1F1] rounded-lg p-2.5" data-testid="bill-kits-note"><PackageX className="w-4 h-4 shrink-0" />{L(...KITS_NOTE)}</p>
    </div>
  );
};
